import styled from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import { ChangeEvent, useState } from "react";
import instance from "src/API/MainAPI";
import logo from "../../../assets/images/logo.png";
import naver from "../../../assets/images/naverLogo.png";
import google from "../../../assets/images/googleLogo.png";
import kakao from "../../../assets/images/kakaoLogo.png";
import apple from "../../../assets/images/appleLogo.png";
import aos from "../../../assets/images/aosQR.png";
import ios from "../../../assets/images/iosQR.png";
import SocialLogin from "../../../API/Auth/socialLogin";
import { useEffect } from "react";
import PhoneVerificationModal from '../../Modal/PhoneVerificationModal';
import axios from "axios";

const Container = styled.div`
  background: linear-gradient(#2282e950, #ffffff00 40%);
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

const Main = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: end;
  gap: 11.4px;
  margin-bottom: 40px;
`;

const LogoImg = styled.img`
  width: 126.72px;
  height: 33px;
`;

const LogoSpan = styled.span`
  font-weight: 500;
  font-size: 18px;
`;

const Text = styled.p`
  color: #555555;
  text-align: center;
  margin-bottom: 77px;
  line-height: 30px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 32px;
  margin-bottom: 80px;
`;

const SocialLogoImg = styled.img`
  width: 71px;
  height: 71px;
  border-radius: 100%;
  cursor: pointer;
`;

const QRContainer = styled.div`
  display: flex;
  gap: 41px;
`;

const QRWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;

const QRImg = styled.img`
  width: 85px;
  height: 85px;
`;

const QRSpan = styled.span`
  font-weight: 600;
  font-size: 12.5px;
  color: #555555;
`;

const Footer = styled.footer`
  color: #d3d3d3;
  text-align: center;
  padding-bottom: 50px;
  font-size: 15px;
  line-height: 24px;
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContainer = styled.div`
  background-color: white;
  border-radius: 10px;
  width: 400px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: relative;
`;

const ModalHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid #ededed;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
`;

const CloseIcon = styled.div`
  cursor: pointer;
  font-size: 20px;
  color: #999;
`;

const ModalBody = styled.div`
   padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const PhoneInput = styled.input`
  flex: 1;
  height: 50px;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 0 15px;
  font-size: 16px;
  
  &:focus {
    outline: none;
    border-color: #2282e9;
  }
`;

const SubmitButton = styled.button`
  width: 50%;
  height: 50px;
  border-radius: 50px;
  background-color: #2282e9;
  color: white;
  font-weight: 600;
  border: none;
  cursor: pointer;
  font-size: 16px;

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;

const ErrorMessage = styled.div`
  color: #ff6b6b;
  font-size: 14px;
  margin-bottom: 10px;
  text-align: center;
`;

// 응답 타입 정의
interface ValidationResponse {
  provider: string;
}

// 결과 표시를 위한 styled-components 추가
const ResultContainer = styled.div`
  text-align: center;
  margin-top: 20px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 5px;
`;

const ProviderText = styled.p`
  font-size: 16px;
  color: #333;
  margin: 0;
  
  span {
    color: #2282e9;
    font-weight: 600;
  }
`;

// 말풍선 스타일 추가
const BubbleContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Bubble = styled.div`
  position: absolute;
  bottom: -40px;
  background: #2282e9;
  color: white;
  padding: 8px 12px;
  border-radius: 20px;
  font-size: 12px;
  white-space: nowrap;
  
  &::after {
    content: '';
    position: absolute;
    top: -6px;
    left: 50%;
    transform: translateX(-50%);
    border-width: 0 6px 6px 6px;
    border-style: solid;
    border-color: transparent transparent #2282e9 transparent;
  }
`;

const InputWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
  width: 100%;
`;

const VerificationButton = styled.button`
  width: 120px;
  height: 50px;
  border-radius: 5px;
  background-color: #2282e9;
  color: white;
  font-weight: 600;
  border: none;
  cursor: pointer;
  font-size: 14px;
  
  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;

const SuccessMessage = styled.p`
  color: #2282e9;
  font-size: 14px;
  margin: 10px 0;
`;

export default function Login() {
  const navigate = useNavigate();
  const [showPhoneModal, setShowPhoneModal] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  // validationResult를 모달 외부에서 독립적으로 관리
  const [validationResult, setValidationResult] = useState<ValidationResponse | null>(null);
  const [showVerificationInput, setShowVerificationInput] = useState(false);
  const [verificationCode, setVerificationCode] = useState('');
  const [isVerified, setIsVerified] = useState(false);
  const [showModalResult, setShowModalResult] = useState(false);

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (token) {
      navigate("/home");
    }
  }, [navigate]);

  // const handlePhoneValidation = async () => {
  //   if (!phoneNumber) {
  //     setErrorMessage('전화번호를 입력해주세요.');
  //     return;
  //   }

  //   try {
  //     const response = await instance.post<ValidationResponse>('/v1/immigrations/validations/phone-registrations', {
  //       phone: phoneNumber
  //     });
  //     setErrorMessage('');
  //     setValidationResult(response.data);
  //     setShowModalResult(true);
  //   } catch (error: any) {
  //     setValidationResult(null);
  //     if (error.response) {
  //       if (error.response.status === 400) {
  //         setErrorMessage('잘못된 전화번호 형식입니다.');
  //       } else if (error.response.status === 404) {
  //         setErrorMessage('등록되지 않은 전화번호입니다.');
  //       } else {
  //         setErrorMessage('전화번호 확인 중 오류가 발생했습니다.');
  //       }
  //     } else {
  //       setErrorMessage('네트워크 오류가 발생했습니다.');
  //     }
  //   }
  // };

  // 인증번호 요청 핸들러
  const handleRequestVerification = async () => {
    // TODO: 실제 인증번호 요청 API 호출
    const response = await axios.post(process.env.REACT_APP_TESTAPI + '/v1/immigrations/validations/phone-registrations',{
      phone: phoneNumber
    });
    console.log(response.data);
    setShowVerificationInput(true);
  };

  const handleVerifyCode = async () => {
    try {
      const response = await axios.post(process.env.REACT_APP_TESTAPI + '/v1/immigrations/validations/phone-registrations/verify-code', {
        phone: phoneNumber,
        verificationCode: verificationCode
      });
      
      if(response.status === 200) {
        // ValidationResponse 형식에 맞게 객체로 설정
        setValidationResult({ provider: response.data.provider });
        console.log("*** "+response.data.provider);
        setShowModalResult(true);
        setIsVerified(true);
        setErrorMessage('')
      }
      if(response.data?.success === false){
        console.log('실패');
        setErrorMessage('인증번호가 일치하지 않습니다.');
      }
    } catch (error: any) {
      console.error('인증 확인 중 오류 발생:', error);
      if(error?.response?.status === 404){
        setErrorMessage('회원 정보가 존재하지 않습니다.');
      } else {
        setErrorMessage('인증번호가 일치하지 않습니다.');
      }
    }
  };

  // 모달 초기화 함수 수정
  const resetModal = () => {
    setShowPhoneModal(false);
    setPhoneNumber('');
    setErrorMessage('');
    setShowVerificationInput(false);
    setVerificationCode('');
    setIsVerified(false);
    setShowModalResult(false);
  };

  // 모달 열 때 이전 결과 유지
  const openModal = () => {
    setShowPhoneModal(true);
    setPhoneNumber('');
    setErrorMessage('');
  };

  // provider 이름을 플랫폼 이름과 매칭하는 함수
  const matchProvider = (buttonProvider: string) => {
    if (!validationResult || !validationResult.provider) return false;
    return validationResult.provider.toUpperCase() === buttonProvider.toUpperCase();
  };

  const handleConfirmButton = async () => {
    try {
      if (!phoneNumber) return;
      
      const response = await instance.post('/v1/immigrations/validations/phone-confirmations', {
        phone: phoneNumber,
        verificationCode: verificationCode
      });

      if (response.status === 200) {
        // 성공적으로 확인된 경우
        setErrorMessage('');
        resetModal();
        // 필요한 경우 추가 처리 (예: 로그인 처리 등)
      }
    } catch (error: any) {
      if (error.response) {
        if (error.response.status === 400) {
          setErrorMessage('잘못된 인증번호입니다.');
        } else {
          setErrorMessage('인증 확인 중 오류가 발생했습니다.');
        }
      } else {
        setErrorMessage('네트워크 오류가 발생했습니다.');
      }
    }
  };

  return (
    <Container>
      <div></div>
      <Main>
        <LogoContainer>
          <LogoImg src={logo} alt="logo" />
          <LogoSpan>플리더스</LogoSpan>
        </LogoContainer>
        <Text>
          플리더스 APP 회원정보로 로그인이 진행됩니다~! <br />
          플리더스 회원이 아닌 경우 플리더스 앱으로 회원가입 진행 후 로그인
          부탁드립니다.
        </Text>
        <ButtonContainer>
          <BubbleContainer>
            <SocialLogoImg src={naver} onClick={() => SocialLogin("naver")} />
            {matchProvider("NAVER") && (
              <Bubble>이 플랫폼으로 가입되어있어요!</Bubble>
            )}
          </BubbleContainer>

          <BubbleContainer>
            <SocialLogoImg src={google} onClick={() => SocialLogin("google")} />
            {matchProvider("GOOGLE") && (
              <Bubble>이 플랫폼으로 가입되어있어요!</Bubble>
            )}
          </BubbleContainer>

          <BubbleContainer>
            <SocialLogoImg src={kakao} onClick={() => SocialLogin("kakao")} />
            {matchProvider("KAKAO") && (
              <Bubble>이 플랫폼으로 가입되어있어요!</Bubble>
            )}
          </BubbleContainer>

          <BubbleContainer>
            <SocialLogoImg src={apple} onClick={() => SocialLogin("apple")} />
            {matchProvider("APPLE") && (
              <Bubble>이 플랫폼으로 가입되어있어요!</Bubble>
            )}
          </BubbleContainer>

        </ButtonContainer>

        <Link to={""} style={{ color: "#2282E9" }} onClick={() => openModal()}>
          휴대폰 번호로 가입 조회하기
        </Link>

        <div style={{ marginBottom: "108px" }} />

        <QRContainer>
          <QRWrapper>
            <QRImg src={aos} />
            <QRSpan>AOS</QRSpan>
          </QRWrapper>
          <QRWrapper>
            <QRImg src={ios} />
            <QRSpan>IOS</QRSpan>
          </QRWrapper>
        </QRContainer>
      </Main>
      <Footer>
        (주)플리더스 대표이사 : 임찬영 사업자 등록번호 : 726-88-02485 <br />
        주소 : 경기도 고양시 덕양구 향동로 201, GL메트로시티 A동 14층 1402호
        이메일 : plithus@naver.com{" "}
      </Footer>

      <PhoneVerificationModal
        isOpen={showPhoneModal}
        onClose={resetModal}
        phoneNumber={phoneNumber}
        setPhoneNumber={(e: ChangeEvent<HTMLInputElement>) => setPhoneNumber(e.target.value)}
        errorMessage={errorMessage}
        showVerificationInput={showVerificationInput}
        verificationCode={verificationCode}
        setVerificationCode={(e: ChangeEvent<HTMLInputElement>) => setVerificationCode(e.target.value)}
        handleRequestVerification={handleRequestVerification}
        handleVerifyCode={handleVerifyCode}
        isVerified={isVerified}
        validationResult={validationResult}
        showModalResult={showModalResult}
        handleConfirmButton={handleConfirmButton}
      />

    </Container>
  );
}
